import { Badge } from "@/components/ui/Badge"
import type { PlanSummary } from "./types"

const LABELS = {
  published: { label: "Published", variant: "success" },
  revising: { label: "Being revised", variant: "warning" },
  draft: { label: "Not published yet", variant: "outline" },
  none: { label: "No plan yet", variant: "outline" },
} as const

/** Where the market's Top Down plan stands; `withVersion` adds "· version 2". */
export default function PlanBadge({ plan, withVersion = false }: { plan: PlanSummary; withVersion?: boolean }) {
  const { label, variant } = LABELS[plan.state]
  const version = withVersion && plan.version_number ? ` · version ${plan.version_number}` : ""
  return <Badge variant={variant}>{label}{version}</Badge>
}
